import React from "react";
import * as dc from "dc";
import {format} from 'd3';
import { TotalTemplate } from "./totalTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    const myChart = dc.numberDisplay(divRef);
    const dimension = ndx.dimension(function (d) {
      return d;
    });
    const all = ndx.groupAll();
  
    const group =  all.reduce(
    function(p, v) { // add
      ++p.count;
      if(p.count > 0) {
        p.total += v.vocabulary_used;
        p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
        // p.tot_conversation_time +=  Math.floor(parseFloat(v.conversation_time));
        // p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avg = 0;
        p.total = 0;
        // p.tot_conversation_time = 0;
        // p.avg_conversation_time = 0;
      }
      return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.total -= v.vocabulary_used;
        p.avg = Math.floor(parseFloat(100*p.total/p.count))/100;
        // p.tot_conversation_time -=  Math.floor(parseFloat(v.conversation_time));
        // p.avg_conversation_time =  Math.floor(parseFloat(100*p.tot_conversation_time/p.count))/100;
      }
      else {
        p.avg = 0;
        p.total = 0;
        // p.tot_conversation_time = 0;
        // p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, avg: 0, total: 0};
    }
  );

    myChart
    .formatNumber(format(",d"))
    .dimension(dimension)
    .group(all)
    .valueAccessor(function (p) {
       return p.total ;
     })
     .transitionDuration(800)


    return myChart
}

export class TotalVocabulary extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TotalTemplate chartFunction={barChartFunc} title={this.props.title}
        dim={this.props.dim} type={this.props.type} />

    );
  }
}
